module.exports = __webpack_public_path__ + "static/media/space-details.f794cc86.svg";